<template>
    <div class="forms__field_group">
        <template v-for="subfield in field.fields">
            <Field
                v-if="typeof modelValue === 'object' && modelValue !== null"
                :key="subfield.slug"
                v-model="modelValue[subfield.slug]"
                :field="subfield"
                :tabindex="tabindex"
                :multiple="multiple"
                :inline="inline"
                :parent="props"
                :size="props.size"
            ></Field>
        </template>
    </div>
</template>

<script setup lang="ts">
import type { FieldComponent } from '@src/Common/Components/types';

const modelValue = defineModel({
    type: [Object, Array, null],
});

const props = withDefaults(defineProps<FieldComponent>(), {});

const buildEmptyFromSubfields = () => {
    const empty = {};
    const subfields = Array.isArray(props.field.fields)
        ? props.field.fields
        : Object.values(props.field.fields ?? {});
    subfields.forEach((subfield) => {
        empty[subfield.slug] = subfield.default ?? null;
    });
    return empty;
};

// Array shape gets serialized without string keys, so repair it to a keyed object.
if (
    typeof modelValue.value === 'undefined'
    || modelValue.value === null
    || Array.isArray(modelValue.value)
) {
    modelValue.value = buildEmptyFromSubfields();
}
</script>
